<template>
  <div>
    <div>
      <span>Every</span>
      <v-menu>
        <template v-slot:activator="{ props }">
          <span v-bind="props" class="mx-2"
            ><u>{{ frequency || "?" }}</u></span
          >
        </template>
        <v-list max-height="250">
          <v-list-item
            v-for="(item, index) in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
            :key="index"
            :value="item"
            @click="frequency = item"
          >
            <v-list-item-title>{{ item }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu>
        <template v-slot:activator="{ props }">
          <span v-bind="props" class="mx-2"
            ><u>{{ type || "weeks" }}</u></span
          >
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in [
              { text: 'Days', value: 'days' },
              { text: 'Weeks', value: 'weeks' },
              { text: 'Months', value: 'months' },
            ]"
            :key="index"
            :value="item.value"
            @click="type = item.value"
          >
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <span v-if="type">at</span>
      <v-menu v-if="type">
        <template v-slot:activator="{ props }">
          <span v-bind="props" class="ml-2"
            ><u>{{ time.hour || "??" }}</u
            >:</span
          >
        </template>
        <v-list max-height="250">
          <v-list-item
            v-for="(item, index) in [
              '00',
              '01',
              '02',
              '03',
              '04',
              '05',
              '06',
              '07',
              '08',
              '09',
              '10',
              '11',
              '12',
              '13',
              '14',
              '15',
              '16',
              '17',
              '18',
              '19',
              '20',
              '21',
              '22',
              '23',
            ]"
            :key="index"
            :value="item"
            @click="time.hour = item"
          >
            <v-list-item-title>{{ item }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu v-if="type">
        <template v-slot:activator="{ props }">
          <span v-bind="props" class="mr-2"
            ><u>{{ time.minute || "??" }}</u></span
          >
        </template>
        <v-list max-height="250">
          <v-list-item
            v-for="(item, index) in [
              '00',
              '01',
              '02',
              '03',
              '04',
              '05',
              '06',
              '07',
              '08',
              '09',
              '10',
              '11',
              '12',
              '13',
              '14',
              '15',
              '16',
              '17',
              '18',
              '19',
              '20',
              '21',
              '22',
              '23',
              '24',
              '25',
              '26',
              '27',
              '28',
              '29',
              '30',
              '31',
              '32',
              '33',
              '34',
              '35',
              '36',
              '37',
              '38',
              '39',
              '40',
              '41',
              '42',
              '43',
              '44',
              '45',
              '46',
              '47',
              '48',
              '49',
              '50',
              '51',
              '52',
              '53',
              '54',
              '55',
              '56',
              '57',
              '58',
              '59',
            ]"
            :key="index"
            :value="item"
            @click="time.minute = item"
          >
            <v-list-item-title>{{ item }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <span v-if="type === 'weeks'">on a</span>
      <v-menu v-if="type === 'weeks'">
        <template v-slot:activator="{ props }">
          <span v-bind="props" class="ml-2"
            ><u>{{ getDayDisplay() || "?" }}</u></span
          >
        </template>
        <v-list max-height="250">
          <v-list-item
            v-for="(item, index) in days"
            :key="index"
            :value="item.value"
            @click="toggleDay(item.value)"
          >
            <v-list-item-title class="d-flex align-center">
              <v-checkbox
                :model-value="isDaySelected(item.value)"
                hide-details
                density="compact"
                class="ma-0"
              ></v-checkbox>
              {{ item.text }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <span v-if="type === 'months'">on the</span>
      <v-menu v-if="type === 'months'">
        <template v-slot:activator="{ props }">
          <span v-bind="props" class="ml-2"
            ><u>{{
              dayItems.find((d) => d.value === month_day)?.text || "?"
            }}</u></span
          >
        </template>
        <v-list max-height="250">
          <v-list-item
            v-for="(item, index) in dayItems"
            :key="index"
            :value="item.value"
            @click="month_day = item.value"
          >
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu v-if="type === 'months'">
        <template v-slot:activator="{ props }">
          <span v-bind="props" class="ml-2"
            ><u>{{ days.find((d) => d.value === singleDay)?.text || "?" }}</u></span
          >
        </template>
        <v-list max-height="250">
          <v-list-item
            v-for="(item, index) in days"
            :key="index"
            :value="item.value"
            @click="day = item.value"
          >
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <span v-if="type === 'months'"> of the month. </span>

      <span v-if="type === 'days'" class="pl-2">Starting next</span>
      <v-menu v-if="type === 'days'">
        <template v-slot:activator="{ props }">
          <span v-bind="props" class="ml-2"
            ><u>{{ days.find((d) => d.value === singleDay)?.text || "?" }}</u></span
          >
        </template>
        <v-list max-height="250">
          <v-list-item
            v-for="(item, index) in days"
            :key="index"
            :value="item.value"
            @click="day = item.value"
          >
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
import { doc, updateDoc } from "firebase/firestore";
import { db } from "@/firebase";
import { mapState } from "vuex";
export default {
  props: {
    category: {
      type: Object,
      required: true,
    },
  },
  watch: {
    scheduleState: {
      handler() {
        if (this.isInitializing) return;
        this.debouncedSave();
      },
      deep: true,
    },
  },
  async mounted() {
    this._categoryUid = this.category.uid;
    await this.fetchSchedule();
  },
  beforeUnmount() {
    if (this._saveTimer) clearTimeout(this._saveTimer);
  },
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      loading: (state) => state.loading,
      categories: (state) => state.posts.categories,
      schedules: (state) => state.schedules.schedules,
    }),
    filteredCategories() {
      return this.categories.filter(
        (c) => !c.schedules || c.schedules.length === 0,
      );
    },
    timeslot() {
      return `${this.time.hour}:${this.time.minute}`;
    },
    singleDay() {
      return Array.isArray(this.day) ? this.day[0] : this.day;
    },
    scheduleState() {
      return {
        type: this.type,
        frequency: this.frequency,
        hour: this.time.hour,
        minute: this.time.minute,
        day: Array.isArray(this.day) ? [...this.day] : this.day,
        month_day: this.month_day,
      };
    },
  },
  data() {
    return {
      isInitializing: false,
      day: [],
      dayItems: [
        { text: "First", value: 1 },
        { text: "2nd", value: 2 },
        { text: "3rd", value: 3 },
        { text: "4th", value: 4 },
        { text: "Last", value: 99 },
      ],
      days: [
        { text: "Monday", value: 1 },
        { text: "Tuesday", value: 2 },
        { text: "Wednesday", value: 3 },
        { text: "Thursday", value: 4 },
        { text: "Friday", value: 5 },
        { text: "Saturday", value: 6 },
        { text: "Sunday", value: 7 },
      ],
      dialog: false,
      frequency: null,
      frequencyItems: ["Days", "Weeks", "Months"],
      month_day: null,
      picker: null,
      time: {
        hour: null,
        minute: null,
      },
      type: "",
    };
  },
  methods: {
    debouncedSave() {
      if (this._saveTimer) clearTimeout(this._saveTimer);
      this._saveTimer = setTimeout(() => {
        this.saveSchedule();
      }, 800);
    },
    async fetchSchedule() {
      this.isInitializing = true;
      const data = this.category.schedule
        ? { ...this.category.schedule }
        : {
            frequency: 1,
            type: "Days",
            timeslot: "00:00",
            day_of_week: [],
            month_day: null,
          };
      this.frequency = data.frequency;
      this.type = data.type;
      this.time = {
        hour: data.timeslot?.split(":")[0] || null,
        minute: data.timeslot?.split(":")[1] || null,
      };
      this.day = data.day_of_week || [];
      this.month_day = data.month_day || null;
      await this.$nextTick();
      this.isInitializing = false;
    },
    toggleDay(dayValue) {
      const index = this.day.indexOf(dayValue);
      if (index > -1) {
        this.day.splice(index, 1);
      } else {
        this.day.push(dayValue);
      }
    },
    isDaySelected(dayValue) {
      return this.day.includes(dayValue);
    },
    getDayDisplay() {
      if (!this.day || this.day.length === 0) return "";
      if (this.day.length === 1) {
        const day = this.days.find((d) => d.value === this.day[0]);
        return day ? day.text : "";
      }
      const dayNames = this.day
        .map((dayValue) => {
          const day = this.days.find((d) => d.value === dayValue);
          return day ? day.text : "";
        })
        .filter((name) => name)
        .sort((a, b) => {
          const aValue = this.days.find((d) => d.text === a)?.value || 0;
          const bValue = this.days.find((d) => d.text === b)?.value || 0;
          return aValue - bValue;
        });

      if (dayNames.length === 0) return "";
      if (dayNames.length === 1) return dayNames[0];
      if (dayNames.length === 2) return dayNames.join(" and ");
      return (
        dayNames.slice(0, -1).join(", ") +
        " and " +
        dayNames[dayNames.length - 1]
      );
    },
    async saveSchedule() {
      if (
        !this.time.hour ||
        !this.time.minute ||
        !this.frequency ||
        !this.type
      ) {
        return;
      }

      const targetUid = this._categoryUid;
      if (!targetUid || targetUid !== this.category.uid) return;

      const dayArray = Array.isArray(this.day)
        ? this.day
        : this.day
          ? [this.day]
          : [];

      const schedule = {
        timeslot: this.timeslot,
        day_of_week: dayArray,
        frequency: Number(this.frequency > 0 ? this.frequency : 1),
        created: Math.floor(Date.now() / 1000),
        created_by_uid: this.userProfile.uid,
        created_by_email: this.userProfile.email,
        category: targetUid,
        type: this.type,
        month_day: this.month_day,
      };

      await updateDoc(
        doc(
          db,
          "workspaces",
          this.userProfile.workspace,
          "categories",
          targetUid,
        ),
        { schedule },
      );

      await this.$store.dispatch("fetchCategories");
      setTimeout(() => {
        this.$store.dispatch("getCalendarDays");
      }, 3000);
    },
  },
};
</script>

<style lang="scss" scoped>
.split {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
  gap: 5px;
}
</style>
